var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8.501,
    x2: 23.499,
    y1: 28.988,
    y2: 3.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#3cacb6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#b90005",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#b90005",
    offset: 0.22586872586872586
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M11.958 10.713a1.001 1.001 0 0 0-1.916 0l-3 10a1 1 0 0 0 1.906.603L9.72 19h2.635l.686 2.287a1 1 0 1 0 1.917-.574zM10.244 17 11 14.48l.756 2.52zM20 10h-2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2c2.757 0 5-2.243 5-5v-2c0-2.757-2.243-5-5-5zm3 7c0 1.654-1.346 3-3 3h-1v-8h1c1.654 0 3 1.346 3 3zM16 1C7.729 1 1 7.729 1 16s6.729 15 15 15 15-6.729 15-15S24.271 1 16 1zm0 28C8.832 29 3 23.168 3 16S8.832 3 16 3s13 5.832 13 13-5.832 13-13 13z",
    opacity: 1,
    "data-original": "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertise);
export default __webpack_public_path__ + "static/media/advertise.151e38882d760938c92f8a4ba864c61c.svg";
export { ForwardRef as ReactComponent };